(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbe-preset-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mbe-preset-showcase')) {
  customElements.define('mbe-preset-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('button');
      if (!this.video || !this.toggle) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.inView = false;
      this.toggle.hidden = false;
      this.setPoster();
      this.video.addEventListener('play', () => this.updateToggle(true), {signal});
      this.video.addEventListener('pause', () => this.updateToggle(false), {signal});
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else this.playVideo();
      }, {signal});
      this.mobile.addEventListener('change', () => {
        this.video.pause();
        this.loadedSource = null;
        this.setPoster();
        if (this.inView && !this.userPaused) this.playVideo();
      }, {signal});
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) {this.userPaused = true; this.video.pause();}
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.inView && !this.userPaused) this.playVideo();
      }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView && !this.userPaused && !document.hidden) this.playVideo();
        else this.video.pause();
      }, {threshold:0.1});
      this.observer.observe(this);
    }
    setPoster() {
      this.video.poster = this.mobile.matches ? this.dataset.mobilePoster : this.dataset.desktopPoster;
    }
    playVideo() {
      const source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (source !== this.loadedSource) {
        this.video.src = source;
        this.video.muted = true;
        this.loadedSource = source;
        this.video.load();
      }
      this.video.play().catch(() => this.updateToggle(false));
    }
    updateToggle(playing) {
      this.toggle.classList.toggle('mbe-is-playing', playing);
      this.toggle.setAttribute('aria-pressed', String(playing));
      this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
